import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

/**
 * @heading1: Password Validation
 * @heading3: Interface
 * @heading4: Password Validation Interface
 * @ol:
 * password {string}
 * @separator:
 */
interface PasswordValidationProps {
  password: string;
}

/**
 * @heading3: Styled Components
 * @heading4: Styled Checkbox Password
 * @block_quotes: Styling text as well as icon.
 * @separator:
 */
const CheckboxPassword = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.mode === 'dark' ? 'rgb(213, 215, 218)' : 'rgba(111,118,126,1)'
}));

/**
 * @heading2: PasswordValidation Component
 * @heading3: Parameter {PasswordValidationProps} password
 * @block_quotes: Password for checking the password validity
 * @separator:
 */
const PasswordValidation: React.FC<PasswordValidationProps> = ({ password }) => {
  // Validation rules
  const rules = [
    { label: 'One or more uppercase and lowercase letters', valid: (/^(?=.*[a-z])(?=.*[A-Z])/u).test(password) },
    { label: 'One special character', valid: (/^(?=.*[@$!%*?&#^])/u).test(password) },
    { label: 'One or more numbers', valid: (/^(?=.*\d)/u).test(password) },
    { label: 'Maximum of 16 characters', valid: (password.length <= 16 && password.length >= 8) },
    { label: 'Minimum of 8 characters', valid: password.length >= 8 }
];
  return (
    <Box display="flex" gap="20px">
      <Box>
        {rules.slice(0, 6).map((rule, index) => (
          <CheckboxPassword key={index} color={rule.valid ? 'success.main' : 'text.secondary'}>
            <CheckCircleOutlineOutlinedIcon
              fontSize="small"
              color={rule.valid ? 'success' : 'disabled'}
            />
            {rule.label}
          </CheckboxPassword>
        ))}
      </Box>
      {/* <Box>
        {rules.slice(3).map((rule, index) => (
          <CheckboxPassword key={index} color={rule.valid ? 'success.main' : 'text.secondary'}>
            <CheckCircleOutlineOutlinedIcon
              fontSize="small"
              color={rule.valid ? 'success' : 'disabled'}
            />
            {rule.label}
          </CheckboxPassword>
        ))}
      </Box> */}
    </Box>
  );
};

export default PasswordValidation;
